import { DnisSdk, type DnisSdkConfig } from "./core";

declare global {
  interface Window {
    HposDnis?: {
      configure: (config: DnisSdkConfig) => void;
      refresh: () => Promise<void>;
    };
  }
}

const scriptElement = document.currentScript instanceof HTMLScriptElement ? document.currentScript : null;
const sdk = new DnisSdk(window, document, scriptElement);

window.HposDnis = {
  configure: sdk.configure,
  refresh: sdk.sync
};

sdk.start();
